<script setup lang="ts">
import type { NewHouseFooterVO } from '~/server/newhouse/interface'

const props = defineProps({
  tdkData: {
    type: Object as () => NewHouseFooterVO,
    default: () => ({}),
  },
})
const titleList = computed(() => {
  const { breadCrumbsList = [] } = props.tdkData || {}
  return breadCrumbsList
})
</script>

<template>
  <div v-if="titleList.length > 0" class="breadcrumb">
    <a-breadcrumb separator=">">
      <a-breadcrumb-item v-for="(item, index) in titleList" :key="index">
        <template v-if="item.pcUrl">
          <a :href="item.pcUrl">{{ item.breadCrumbsName }}</a>
        </template>
        <template v-else>
          <strong>{{ item.breadCrumbsName }}</strong>
        </template>
      </a-breadcrumb-item>
      <!--    <a-breadcrumb-item>Home</a-breadcrumb-item> -->
      <!--    <a-breadcrumb-item href=""> -->
      <!--      Application Center -->
      <!--    </a-breadcrumb-item> -->
      <!--    <a-breadcrumb-item href=""> -->
      <!--      Application List -->
      <!--    </a-breadcrumb-item> -->
      <!--    <a-breadcrumb-item>An Application</a-breadcrumb-item> -->
    </a-breadcrumb>
  </div>
</template>

<style scoped lang="scss">
.breadcrumb {
  margin: 30px 0;
  strong{
    font-weight: normal;
  }
}
</style>
